module.exports = __webpack_public_path__ + "img/12.0e7050d6.png";